export function filterCells(event, column, orgaWithChart) {
    // column.column_type => allow to filter on the specific column
    // true => The column is displayed
    // false => The column is hidden

    //Hide the column quota when there is a session
    if (column.quota && event.use_sessions) {
        return false;
    }

    // Hide inventories column
    if (column.seating) {
        if (
            (!orgaWithChart && !event) || // if no chart at orga level
            !event?.chart || // if no chart (classic case)
            event?.use_sessions || // if sessions
            (event?.isFakeSeating() && !event?.isFakeSeatingMultipleInventories()) // if fake seating with 1 inventory
        ) {
            return false;
        }
    }

    return true;
}

export function deleteRates({ rateClass, ratesToDelete = [], rates = [], onDone = () => {}, toastError = () => {}, organizationId, eventId = null }) {
    if (ratesToDelete.length > 1) {
        return rateClass
            .destroy(ratesToDelete, { organizationId, eventId: eventId })
            .then(() => {
                onDone();
            })
            .catch(e => {
                console.error(e);
                toastError();
            });
    }

    let rate = ratesToDelete[0];

    return rate
        .delete({
            organizationId,
            eventId: eventId ? eventId : null
        })
        .then(() => {
            //handle display_group
            let editedRates = [];
            let tmpRates = rates.filter(frate => frate.group === rate.group && frate.pk !== rate.pk);

            tmpRates.forEach(frate => {
                if (rate.display_order < frate.display_order) {
                    frate.display_order -= 1;
                    frate.translations = { name: {} };
                    editedRates.push(frate);
                }
            });
            rateClass
                .save(editedRates, {
                    organizationId,
                    eventId: eventId ? eventId : null
                })
                .then(() => {
                    onDone();
                });
        })
        .catch(e => {
            console.error(e);
            toastError();
        });
}

export function compute_sum_float(f1, f2) {
    // toFixed on IE have some bad behavior
    return Math.round((f1 + f2) * 1e12) / 1e12;
}
